import { render, staticRenderFns } from "./TablaAmortizaciones.vue?vue&type=template&id=521350e0&"
import script from "./TablaAmortizaciones.vue?vue&type=script&lang=js&"
export * from "./TablaAmortizaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports